export const DEFAULT_REFERENCE_QUESTIONS = [
  "General overview — where and when you worked together + key projects",
  "Where is the candidate the most different from their peers — what is their strongest and weakest point as a professional?",
  "If I asked someone who didn't have a positive experience working with them, what would they say?",
  "How would you describe their approach to work? How important is their professional life to them?",
  "Startups evolve quickly — how does the candidate handle ambiguity or shifting priorities?",
  "Between delivering with speed and quality, how would you describe their work?",
  "When they get stuck in a problem, what do they do?",
  "What advice would you give for their manager to get the most out of them?",
  "Hard to answer, but please try to classify them on a percentile basis compared to all ICs (individual contributors) senior and staff engineers. Are they in the top 50%? Top 5%? Top .5%? Why?",
];

export type ReferenceCheckTemplate = {
  questions: string[];
};
